import React from "react";
import SvgIcon from "../SvgIcon";

export function Twitter({ color, size, classname }) {
    return (
        <SvgIcon color={color} fontSize={size} className={classname}> 
            <g clip-path="url(#a)"><mask id="b" style={{maskType: "luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="19"><path d="M19.303.176H.523v18.78h18.78z" fill="#fff"/></mask><g mask="url(#b)"><path d="M13.578 3.844h1.941l-4.241 4.848 4.99 6.596H12.36l-3.06-4-3.502 4H3.857l4.536-5.185-4.786-6.259h4.006l2.766 3.657zm-.681 10.282h1.075l-6.944-9.18H5.874z" fill="#446475"/></g></g><defs><clipPath id="a"><path fill="#fff" d="M.523.176h18.78v18.78H.523z"/></clipPath></defs>
        </SvgIcon>
    );
}
